/**
 * Floor.vueで使用するユーティリティ関数
 * テスト可能にするためにsetupから切り出し
 */

// 残り時間の警告閾値（ミリ秒）
// - ENDING: 卓カードを「終了間近」(黄色アニメーション) 表示する閾値
// - EXPIRING_SOON: サイドパネル等で残り時間を「警告」(赤テキスト) 表示する閾値
export const ENDING_THRESHOLD_MS = 10 * 60000
export const EXPIRING_SOON_THRESHOLD_MS = 5 * 60000

export const formatElapsed = (startAt, now) => {
  if (!startAt) return '--:--'
  const diff = now - new Date(startAt).getTime()
  if (diff < 0) return '00:00'
  const h = Math.floor(diff / 3600000)
  const m = Math.floor((diff % 3600000) / 60000)

  return `${h}:${String(m).padStart(2, '0')}`
}

export const formatRemaining = (expireAt, now) => {
  if (!expireAt) return ''
  const diff = new Date(expireAt).getTime() - now
  if (diff <= 0) return '超過'
  const m = Math.floor(diff / 60000)

  return `${m}分`
}

export const isExpiringSoon = (expireAt, now) => {
  if (!expireAt) return false
  const diff = new Date(expireAt).getTime() - now

  return diff <= EXPIRING_SOON_THRESHOLD_MS
}

export const formatTime = dt => {
  if (!dt) return ''
  const d = new Date(dt)

  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
}

export const parseStoredCompactMode = stored => stored === 'true'

export const buildFreeCastUserIds = (currentIds, castId) => {
  const ids = currentIds || []
  const id = Number(castId)
  if (ids.map(Number).includes(id)) return null

  return [...ids, id]
}

export const buildNominationVendingHistoryParams = (nomination, castId) => ({
  vendibleType: 'Nomination',
  vendibleId: nomination.id,
  sellingPrice: nomination.attributes.sellingPrice || 0,
  taxCharge: nomination.attributes.taxCharge || 'normal',
  isNonExistVendible: false,
  vendibleRecipientsAttributes: [{ userId: Number(castId), ratio: 1 }],
})

const DUMMY_CAST_NAMES = ['サンプルA', 'サンプルB', 'サンプルC', 'サンプルD']
const DUMMY_VENDIBLE_NAMES = ['本指名', '場内指名', '同伴指名']

export const generateDummyCasts = count => {
  const result = []
  for (let i = 0; i < count; i += 1) {
    if (i === 0) {
      result.push({ type: 'free', userId: -1, name: DUMMY_CAST_NAMES[0] })
    } else {
      result.push({
        type: 'nomination',
        userId: -(i + 1),
        name: DUMMY_CAST_NAMES[i % DUMMY_CAST_NAMES.length],
        vendibleName: DUMMY_VENDIBLE_NAMES[(i - 1) % DUMMY_VENDIBLE_NAMES.length],
      })
    }
  }

  return result
}

export const splitCastsForDisplay = (casts, maxVisible = 2) => ({
  visible: casts.slice(0, maxVisible),
  overflowCount: Math.max(0, casts.length - maxVisible),
})

export const getTableCasts = (table, users) => {
  const result = []
  // フリー（cast_user_ids）
  const castIds = table?.attributes?.castUserIds || []
  castIds.forEach(uid => {
    const user = users.find(u => Number(u.id) === Number(uid))
    if (user) {
      result.push({
        type: 'free',
        userId: Number(uid),
        name: user.attributes?.name || `ID:${uid}`,
      })
    }
  })
  // 指名（currentNominations）
  const noms = table?.meta?.currentNominations?.data || []
  noms.forEach(nom => {
    const recipients = nom?.attributes?.vendibleRecipients?.data || []
    const recipientCount = recipients.length
    recipients.forEach(r => {
      const name = r?.attributes?.recipient?.data?.attributes?.name
      const uid = r?.attributes?.userId
      if (name && !result.find(c => c.userId === Number(uid))) {
        result.push({
          type: 'nomination',
          userId: Number(uid),
          vendingHistoryId: nom.id,
          vendibleRecipientId: r.id,
          recipientCount,
          name,
          vendibleName: nom?.attributes?.vendibleName || '指名',
        })
      }
    })
  })

  return result.slice(0, 4)
}
